import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loading", "video", "error", "errorMessage"]
  static values = { url: String }

  connect() {
    this.loadVideoInfo()
  }

  async loadVideoInfo() {
    try {
      const response = await fetch(this.urlValue, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (response.ok) {
        const data = await response.json()
        this.showVideo(data.embed_code)
      } else {
        const errorData = await response.json()
        this.showError(errorData.error || "Unable to load video")
      }
    } catch (error) {
      this.showError("Unable to load video")
    }
  }

  showVideo(embedCode) {
    if (this.hasVideoTarget) {
      this.videoTarget.innerHTML = embedCode
      this.videoTarget.classList.remove("hidden")
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("hidden")
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add("hidden")
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("hidden")
    }
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
    }
    if (this.hasVideoTarget) {
      this.videoTarget.classList.add("hidden")
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add("hidden")
    }
  }
}
